// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { getProp } from "@insite/mobius/utilities";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.checkBox = {};

productListFilterAccordionSectionStyles.checkBoxSelected = {};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        &:not(:last-child) {
            padding-bottom: 12px;
        }
    `,
};

productListFilterAccordionSectionStyles.accordionSection = {
    mergeCss: true,
    headerProps: {
        css: css`
            margin-bottom: 8px;

            &&&& {
                ${/* sc-selector */ AccordionSectionPanel} + & button {
                    border-top: 1px solid ${color("common.border")};
                }
                ${getProp("theme.accordion.sectionDefaultProps.headerProps.css")}
            }
        `,
    },
    panelProps: {
        css: css`
            margin-top: -8px;
            margin-bottom: 8px;
        `,
    },
};
